export type RepositoryRegistry = 'github' | 'gitlab';

export function inferRepositoryRegistryFromUrl(sourceUrl: string): RepositoryRegistry | null {
  try {
    const url = new URL(sourceUrl.trim());
    if (url.protocol !== 'http:' && url.protocol !== 'https:') {
      return null;
    }

    return url.hostname.toLowerCase() === 'github.com' ? 'github' : 'gitlab';
  } catch {
    return null;
  }
}
